<template>
    <list :testId="testId" />
</template>
<script>
import List from './Show/List'


export default {
    components: {
        List
    },
    computed: {
        testId () {
            return this.$route.params.testId
        },
    },
}
</script>
